// extracted by mini-css-extract-plugin
module.exports = {"clickableBox":"Topbar_clickableBox__JLF4j"};